import { mapActions } from "vuex"
import { resetCrispSession } from "@/utils/crispChatUtils"

export default {
  methods: {
    ...mapActions('auth', [
      'logout'
    ]),

    ...mapActions('softphone', [
      'teardownSoftphone'
    ]),

    /**
     * The softphone goes first, while the session can still authenticate the pause. Logging out
     * used to leave the transport registered and the campaign Active behind a login page: the
     * dashboard layout is destroyed by the redirect, and the store reset that follows wipes the
     * softphone's state without touching the transport or the ownership lock behind it.
     *
     * Awaited, and through the normal path rather than the keepalive one, so an expired token is
     * refreshed on the way. `logout` itself only fires a best-effort teardown - see the action.
     */
    async logoutAndRedirect() {
      try {
        await this.teardownSoftphone()
      } catch (error) {
        console.error('Failed to tear the softphone down before logging out', error)
      }

      try {
        this.logout()
        resetCrispSession()
      } catch (error) {
      //
      } finally {
        this.$router.push({ name: 'Login' })
      }
    },

  },
}
